import { get } from './axios.js'

let api = '/api'

export const getFooterLink = () => get(api + '/getPortalList')
